import React from 'react';
import Transactions from '.';

const SettlementTransactions = () => (
  <>
    <Transactions
      title="Settlement Transactions"
      transactionType="SETTLEMENT"
    />
  </>
);

export default SettlementTransactions;
